import { useQuery } from '@tanstack/react-query';
import { fetcher } from '../libs';

type AccountsPersonalInfo = {
  id: string;
  name: string;
  sex: 'MALE' | 'FEMALE';
  birthday: string;
};

export default function usePersonalInfoQuery() {
  return useQuery(['onboard', 'personal-info'], () => {
    return fetcher<AccountsPersonalInfo>('/accounts/personal-info');
  });
}
